import React from 'react';
import {
  Button,
  Modal,
  Typography
} from '@npm-registry/eapteka-ui';
import styles from './Fallback.scss';
import { text } from '../../../text';

export const Fallback = () => {
  return (
    <Modal visible={true}>
      <div className={styles.root}>
        <header className={styles.header}>
          <Typography className={styles.title}>
            {text['fallback.title']}
          </Typography>
        </header>
        <footer className={styles.footer}>
          <Button
            className={styles.button}
            type="button"
            variant="outlinedSolid"
            onClick={() => location.reload()}
          >
            {text['fallback.reload']}
          </Button>
        </footer>
      </div>
    </Modal>
  );
};
